/* global Event */
import { trackCustomClickInAmplitude } from '../analytics/CustomEvents'

export default function initCustomSelects (container = document) {
  const selects = Array.from(container.querySelectorAll('.vjs-custom-select__container select'))
  selects.forEach(mapSelectToProxy)
}

// For copied markup: the copy's proxies carry no listeners, so rebuild them.
export function reinitCustomSelects (container) {
  container.querySelectorAll('.vjs-proxy-select__display, .vjs-proxy-select__menu').forEach(proxy => proxy.remove())
  initCustomSelects(container)
}

function mapSelectToProxy (select) {
  const selectOptions = Array.from(select.getElementsByTagName('option'))
  const proxySelect = hideSelectAndGetProxy(select)
  const proxyMenu = getProxyDropDown(proxySelect)
  const proxyOptions = getProxyLisFromOptions(selectOptions, select, proxySelect)

  proxyOptions.forEach((proxyOption, index) => {
    proxyMenu.appendChild(proxyOption)
    proxyOption.addEventListener('click', () => handleChooseMenuItem(selectOptions[index], select, proxySelect))
  })

  // Update proxy when changing value on underlying select
  select.addEventListener('click', () => {
    handleChooseMenuItem(selectOptions[select.selectedIndex], select, proxySelect)
  })

  // start proxy innerText on already selected input option or first
  if (select.selectedIndex) {
    proxySelect.innerText = selectOptions[select.selectedIndex].innerText
  } else {
    proxySelect.innerText = selectOptions[0].innerText
  }
  setUpMenuOpenAndClose(proxySelect, select)

  const typeToSearchState = {
    currentlyTyping: '',
    timeout: null
  }

  proxySelect.addEventListener('keydown', e => {
    const isAlphanumericKey = e.key.length === 1 && /[a-zA-Z0-9]/.test(e.key)

    if (isAlphanumericKey) {
      clearTimeout(typeToSearchState.timeout)

      const newSearchString = typeToSearchState.currentlyTyping + e.key.toLowerCase()
      const matchingOption = selectOptions.find(option => option.innerText.toLowerCase().startsWith(newSearchString))

      if (matchingOption) {
        handleChooseMenuItem(matchingOption, select, proxySelect)
        dispatchChangeEvent(select)
      }

      typeToSearchState.currentlyTyping = newSearchString
      typeToSearchState.timeout = setTimeout(() => {
        if (matchingOption) handleTypeToSearchAmplitudeEvent(matchingOption, proxySelect)
        typeToSearchState.currentlyTyping = ''
      }, 1000)
    }
  })
}

function handleTypeToSearchAmplitudeEvent (matchingOption, proxySelect) {
  const selectComponentName = proxySelect.parentElement.querySelector('label')?.innerText || ''

  Object.assign(proxySelect.dataset, {
    amplitudeEventName: 'Custom select: type to find option',
    amplitudeCustomSelectMenu: selectComponentName,
    amplitudeSelectedOption: matchingOption.innerText
  })
  trackCustomClickInAmplitude(proxySelect)
}

function hideSelectAndGetProxy (select) {
  select.classList.add('vsd-native-select--hidden')

  const proxySelect = document.createElement('div')
  proxySelect.classList.add('vsd-proxy-select__display', 'vjs-proxy-select__display')

  proxySelect.tabIndex = '0'
  select.insertAdjacentElement('afterend', proxySelect)

  return proxySelect
}

function getProxyDropDown (proxySelect) {
  const proxyMenu = document.createElement('ul')
  proxySelect.insertAdjacentElement('afterend', proxyMenu)
  proxyMenu.classList.add('vsd-proxy-select__menu', 'vjs-proxy-select__menu')

  return proxyMenu
}

function getProxyLisFromOptions (selectOptions) {
  return selectOptions.map(selectOption => {
    const optionText = selectOption.innerText
    const proxyLi = document.createElement('li')

    proxyLi.innerText = optionText
    Object.assign(proxyLi.dataset, selectOption.dataset)

    if (optionText === 'Please select' || selectOption.value === '') {
      proxyLi.classList.add('hidden')
    }

    return proxyLi
  })
}

function handleChooseMenuItem (selectOption, select, proxySelect) {
  select.selectedIndex = selectOption.index
  proxySelect.innerText = selectOption.innerText

  selectOption.click()
}

function setUpMenuOpenAndClose (proxySelect, select) {
  const selectContainer = proxySelect.parentElement
  proxySelect.addEventListener('click', e => {
    e.stopPropagation()
    if (e.target.parentElement?.matches('.vsd-field--disabled')) return

    const clickedMenuIsAlreadyOpen = selectContainer.classList.contains('vsd-custom-select__container--open')

    if (clickedMenuIsAlreadyOpen) {
      selectContainer.classList.remove('vsd-custom-select__container--open')
    } else {
      closeAllSelectMenus()
      selectContainer.classList.add('vsd-custom-select__container--open')
    }

    handleClicksOutsideMenu(select)
  })
}

function handleClicksOutsideMenu (select) {
  document.addEventListener('click', e => {
    e.stopPropagation()
    if (e.target.parentElement?.matches('.vjs-proxy-select__menu')) return
    closeAllSelectMenus()
    dispatchChangeEvent(select)
  }, { once: true })
}

function closeAllSelectMenus () {
  const selectMenus = Array.from(document.querySelectorAll('.vjs-custom-select__container'))
  selectMenus.forEach(selectMenu => selectMenu.classList.remove('vsd-custom-select__container--open'))
}

function dispatchChangeEvent (select) {
  const changeEvent = new Event('change', {
    view: window,
    bubbles: true
  })

  select.dispatchEvent(changeEvent)
}
